import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from './api.service';

import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import { AuthService } from 'app/core/services/auth/auth.service';
/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
@Injectable({
    providedIn: 'root'
})
export class ApiPrefixInterceptor implements HttpInterceptor {

    constructor(private api: ApiService,
                private router: Router,
                private authService : AuthService) {

    }

    intercept(request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!/^(http|https):/i.test(request.url)) {
            request = request.clone({
                url: environment.serverUrl + request.url
            });
        }
        request = request.clone({
            setHeaders: {
                // TODO make sure is Bearer type
                Authorization: `Bearer ${this.api.getToken()}`
            }
        });

        return next.handle(request).pipe(tap(() => { },
            (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status !== 401) {
                        console.log(err);
                        return;
                    }

                    this.authService.logout();
                    this.router.navigate(['auth', 'login']);
                }
        }));

        // return next.handle(request);
    }
}
